import React, { useEffect, useState, createElement } from 'react';
import { Clock, Dumbbell, Flame, Check, X, Zap, Shield, ArrowRight, Play, Battery } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
type ModalType = 'privacy' | 'terms' | null;
const CHECKOUT_URL = 'https://oriammarketing.com/cart/45489887674566:1';
const META_PIXEL_ID = '2324471648025132';
export function LandingPage() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Initialize Meta Pixel and fire PageView on mount
  useEffect(() => {
    // Load Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      // Cleanup on unmount
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  // Track AddToCart event
  const trackAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Rutina Exprés: Fitness 15',
        content_type: 'product',
        value: 6.97,
        currency: 'USD'
      });
    }
  };
  // Handle checkout click with tracking
  const handleCheckoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackAddToCart();
    // Small delay to ensure tracking fires before redirect
    setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 100);
  };
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const closeModal = () => setActiveModal(null);
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-[#00ff88] selection:text-black" data-id="element-1">
      {/* 1. HERO SECTION */}
      <section className="relative pt-12 pb-16 px-4 md:pt-20 md:pb-24 overflow-hidden" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-3">
          <div className="inline-block mb-4 px-3 py-1 rounded-full border border-[#00ff88]/30 bg-[#00ff88]/10 text-[#00ff88] text-sm font-bold tracking-wide uppercase" data-id="element-4">
            Sistema ME15
          </div>
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter leading-[0.95] mb-6 text-white" data-id="element-5">
            15 MINUTOS. <br data-id="element-6" />
            <span className="text-[#00ff88]" data-id="element-7">CERO NEGOCIACIÓN.</span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto font-medium" data-id="element-8">
            La rutina para gente que siempre abandona.
          </p>

          <div className="relative mx-auto max-w-md mb-10 group" data-id="element-9">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00ff88] to-emerald-600 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000" data-id="element-10"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pmu2XMUr84QAwkWQJHm93g/rutina_expres.png" alt="Rutina Exprés Fitness 15 en tablet" className="relative rounded-xl shadow-2xl border border-gray-800 w-full transform transition duration-500 hover:scale-[1.02]" data-id="element-11" />
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-12">
            <button onClick={scrollToPricing} className="w-full md:w-auto bg-[#00ff88] hover:bg-[#00cc6a] text-black font-black text-xl py-4 px-8 rounded-lg transform transition hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(0,255,136,0.4)] flex items-center justify-center gap-2 uppercase tracking-tight" data-id="element-13">
              Quiero Empezar
              <ArrowRight className="w-6 h-6" data-id="element-14" />
            </button>
            <p className="text-sm text-gray-500 font-medium flex items-center gap-2" data-id="element-15">
              <Shield className="w-4 h-4" data-id="element-16" /> Pago único. Descarga inmediata.
            </p>
          </div>
        </div>

        {/* Background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-0 pointer-events-none" data-id="element-17">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#00ff88] rounded-full mix-blend-multiply filter blur-[128px] opacity-10" data-id="element-18"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-800 rounded-full mix-blend-multiply filter blur-[128px] opacity-10" data-id="element-19"></div>
        </div>
      </section>

      {/* 2. OPENING LEAD (Empathy) */}
      <section className="py-16 px-4 bg-[#111111] border-y border-gray-900" data-id="element-20">
        <div className="max-w-2xl mx-auto" data-id="element-21">
          <div className="bg-[#1a1a1a] p-8 md:p-10 rounded-2xl border border-gray-800 shadow-xl relative overflow-hidden" data-id="element-22">
            <div className="absolute top-0 left-0 w-1 h-full bg-[#00ff88]" data-id="element-23"></div>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-24">
              Si eres de los que empieza fuerte… y a la semana desaparece, no es
              porque{' '}
              <span className="text-white font-bold" data-id="element-25">
                "te falte disciplina"
              </span>
              .
            </p>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6" data-id="element-26">
              Es porque casi todo el fitness está diseñado para alguien con otra
              vida. La tuya tiene trabajo, estrés, pendientes, cansancio y cero
              paciencia para rutinas eternas.
            </p>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-8" data-id="element-27">
              Y aun así — en algún lugar de tu cabeza — sigue esa idea:
            </p>
            <h3 className="text-2xl md:text-3xl font-bold text-white italic border-l-4 border-gray-700 pl-6 py-2" data-id="element-28">
              "Necesito hacer algo con mi cuerpo… pero no me da la vida."
            </h3>
            <p className="mt-8 text-[#00ff88] font-bold text-lg uppercase tracking-wide" data-id="element-29">
              Esto es exactamente para eso.
            </p>
          </div>
        </div>
      </section>

      {/* 3. WHAT IS ME15 (Mechanism) */}
      <section className="py-20 px-4 relative" data-id="element-30">
        <div className="max-w-4xl mx-auto" data-id="element-31">
          <div className="text-center mb-16" data-id="element-32">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-33">
              EL SISTEMA <span className="text-[#00ff88]" data-id="element-34">ME15</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-35">
              Mínimo Efectivo 15. Un sistema de 4 bloques fijos que elimina la
              fricción mental.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-12" data-id="element-36">
            {[{
            title: 'Calentar',
            time: '2 min',
            icon: <Battery className="w-6 h-6" data-id="element-37" />,
            color: 'bg-gray-800'
          }, {
            title: 'Fuerza',
            time: '7 min',
            icon: <Dumbbell className="w-6 h-6" data-id="element-38" />,
            color: 'bg-emerald-900/40 border-[#00ff88]/30'
          }, {
            title: 'Quema',
            time: '4 min',
            icon: <Flame className="w-6 h-6" data-id="element-39" />,
            color: 'bg-emerald-900/60 border-[#00ff88]/60'
          }, {
            title: 'Cierre',
            time: '2 min',
            icon: <Check className="w-6 h-6" data-id="element-40" />,
            color: 'bg-gray-800'
          }].map((block, i) => <div key={i} className={`relative p-6 rounded-xl border border-gray-800 ${block.color} flex flex-col items-center text-center transition hover:border-[#00ff88] group`} data-id="element-41">
                <div className="mb-3 p-3 bg-black rounded-full text-[#00ff88] group-hover:scale-110 transition-transform" data-id="element-42">
                  {block.icon}
                </div>
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-43">
                  {block.title}
                </h3>
                <p className="text-sm text-[#00ff88] font-mono" data-id="element-44">{block.time}</p>
                {i < 3 && <div className="hidden md:block absolute top-1/2 -right-2 w-4 h-0.5 bg-gray-700 z-10" data-id="element-45"></div>}
              </div>)}
          </div>

          <div className="bg-[#111111] rounded-xl p-6 md:p-8 border border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-46">
            <div data-id="element-47">
              <h4 className="text-xl font-bold text-white mb-2" data-id="element-48">
                Sin gimnasio. Sin equipo caro.
              </h4>
              <p className="text-gray-400" data-id="element-49">
                Solo necesitas 15 minutos y una banda elástica.
              </p>
            </div>
            <div className="flex gap-4" data-id="element-50">
              <div className="flex flex-col items-center" data-id="element-51">
                <span className="text-3xl font-black text-[#00ff88]" data-id="element-52">15</span>
                <span className="text-xs text-gray-500 uppercase" data-id="element-53">Minutos</span>
              </div>
              <div className="w-px h-12 bg-gray-800" data-id="element-54"></div>
              <div className="flex flex-col items-center" data-id="element-55">
                <span className="text-3xl font-black text-[#00ff88]" data-id="element-56">4</span>
                <span className="text-xs text-gray-500 uppercase" data-id="element-57">Semanas</span>
              </div>
              <div className="w-px h-12 bg-gray-800" data-id="element-58"></div>
              <div className="flex flex-col items-center" data-id="element-59">
                <span className="text-3xl font-black text-[#00ff88]" data-id="element-60">5</span>
                <span className="text-xs text-gray-500 uppercase" data-id="element-61">
                  Días/Sem
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. WHO IT'S FOR */}
      <section className="py-20 px-4 bg-[#111111] border-y border-gray-900" data-id="element-62">
        <div className="max-w-5xl mx-auto" data-id="element-63">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-64">
            {/* Para ti */}
            <div className="bg-[#0a0a0a] p-8 rounded-2xl border border-[#00ff88]/20 shadow-[0_0_30px_rgba(0,255,136,0.05)]" data-id="element-65">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-66">
                <span className="bg-[#00ff88] text-black p-1 rounded-md" data-id="element-67">
                  <Check className="w-5 h-5" data-id="element-68" />
                </span>
                Esto ES para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-69">
                {['Tienes 25–45, trabajas, te sientes sin tiempo', "Quieres bajar grasa y sentir el cuerpo 'reactivado'", 'Estás regresando (y no quieres lastimarte ni frustrarte)', 'Buscas consistencia real, no perfecta'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-70">
                    <Check className="w-5 h-5 text-[#00ff88] flex-shrink-0 mt-0.5" data-id="element-71" />
                    <span data-id="element-72">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* No es para ti */}
            <div className="bg-[#0a0a0a] p-8 rounded-2xl border border-red-900/30 opacity-80" data-id="element-73">
              <h3 className="text-2xl font-bold text-gray-200 mb-6 flex items-center gap-3" data-id="element-74">
                <span className="bg-red-500 text-white p-1 rounded-md" data-id="element-75">
                  <X className="w-5 h-5" data-id="element-76" />
                </span>
                NO es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-77">
                {['Quieres un plan avanzado de hipertrofia pesada', 'Te encanta entrenar 90 minutos', "Buscas 'la rutina más intensa del planeta' para castigarte", 'Crees que más dolor = más resultados'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-78">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-79" />
                    <span data-id="element-80">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 5. WHY OLD SOLUTIONS FAIL */}
      <section className="py-20 px-4" data-id="element-81">
        <div className="max-w-3xl mx-auto text-center" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-83">
            Por qué lo que intentaste antes falló{' '}
            <span className="text-gray-500 block text-xl mt-2 font-normal" data-id="element-84">
              (sin culpa)
            </span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12 text-left" data-id="element-85">
            {[{
            title: 'Demasiado tiempo',
            desc: 'Rutinas de 60-90 min que no caben en tu agenda.'
          }, {
            title: 'Demasiadas decisiones',
            desc: '¿Qué hago hoy? ¿Cuánto peso? La duda mata la acción.'
          }, {
            title: "Demasiado 'perfecto'",
            desc: 'Si fallas un día, sientes que arruinaste todo.'
          }, {
            title: 'Dependiente de motivación',
            desc: 'Esperas tener ganas para empezar.'
          }].map((item, i) => <div key={i} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-86">
                <div className="w-2 h-2 bg-red-500 rounded-full mb-3" data-id="element-87"></div>
                <h4 className="text-lg font-bold text-white mb-1" data-id="element-88">
                  {item.title}
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-89">{item.desc}</p>
              </div>)}
          </div>

          <blockquote className="text-2xl md:text-3xl font-serif italic text-gray-300 border-l-4 border-[#00ff88] pl-6 py-2 text-left md:text-center md:border-l-0 md:border-t-4 md:pt-6" data-id="element-90">
            "La motivación es un empleado que renuncia sin avisar."
          </blockquote>
          <p className="mt-6 text-[#00ff88] font-bold uppercase tracking-wide" data-id="element-91">
            ME15 funciona con tu vida real, no con tu vida ideal.
          </p>
        </div>
      </section>

      {/* 6. WHAT'S INCLUDED */}
      <section className="py-20 px-4 bg-[#111111] border-y border-gray-900" data-id="element-92">
        <div className="max-w-4xl mx-auto" data-id="element-93">
          <div className="text-center mb-12" data-id="element-94">
            <h2 className="text-4xl font-black text-white mb-4" data-id="element-95">
              LO QUE RECIBES
            </h2>
            <p className="text-gray-400" data-id="element-96">Acceso inmediato al PDF completo</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-97">
            <div className="space-y-6" data-id="element-98">
              {['Plan completo de 4 semanas / 5 días', 'Sesiones ME15 listas (solo ejecutar)', 'Progresión semanal mínima', 'Guía de técnica + adaptaciones', 'Nutrición mínima viable (sin dieta estricta)'].map((feature, i) => <div key={i} className="flex items-center gap-4 p-4 bg-[#0a0a0a] rounded-xl border border-gray-800" data-id="element-99">
                  <div className="bg-[#00ff88]/10 p-2 rounded-full text-[#00ff88]" data-id="element-100">
                    <Check className="w-5 h-5" data-id="element-101" />
                  </div>
                  <span className="text-white font-medium" data-id="element-102">{feature}</span>
                </div>)}
            </div>

            <div className="bg-[#1a1a1a] p-6 rounded-xl border border-[#00ff88]/30 relative overflow-hidden" data-id="element-103">
              <div className="absolute top-0 right-0 bg-[#00ff88] text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-104">
                EXCLUSIVO
              </div>
              <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-105">
                <Shield className="w-5 h-5 text-[#00ff88]" data-id="element-106" />
                Sistema Antiabandono
              </h3>
              <p className="text-gray-400 mb-6 text-sm" data-id="element-107">
                Porque habrá días malos. El sistema incluye 3 versiones para que
                nunca rompas la cadena:
              </p>
              <ul className="space-y-3" data-id="element-108">
                <li className="flex justify-between items-center text-sm border-b border-gray-800 pb-2" data-id="element-109">
                  <span className="text-white" data-id="element-110">Versión Completa</span>
                  <span className="text-[#00ff88] font-mono" data-id="element-111">15 min</span>
                </li>
                <li className="flex justify-between items-center text-sm border-b border-gray-800 pb-2" data-id="element-112">
                  <span className="text-white" data-id="element-113">Versión Salvavidas</span>
                  <span className="text-yellow-400 font-mono" data-id="element-114">7 min</span>
                </li>
                <li className="flex justify-between items-center text-sm" data-id="element-115">
                  <span className="text-white" data-id="element-116">Versión Mínima</span>
                  <span className="text-red-400 font-mono" data-id="element-117">3 min</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 7. THE REAL CHANGE (Emotional) */}
      <section className="py-24 px-4 relative overflow-hidden" data-id="element-118">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-119"></div>
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-121">
            NO COMPRAS "EJERCICIOS". <br data-id="element-122" />
            COMPRAS ESTO:
          </h2>
          <div className="bg-[#00ff88] text-black p-8 md:p-12 rounded-2xl shadow-[0_0_50px_rgba(0,255,136,0.2)] transform rotate-1 hover:rotate-0 transition duration-300" data-id="element-123">
            <p className="text-2xl md:text-4xl font-black italic leading-tight" data-id="element-124">
              "La sensación de terminar el día y poder decir: YA LO HICE."
            </p>
          </div>
          <p className="mt-8 text-xl text-gray-300" data-id="element-125">
            Aunque el día haya sido un caos. Esa es la semilla de la constancia.
          </p>
        </div>
      </section>

      {/* 8. PRICING & FINAL CTA */}
      <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-[#0a0a0a] to-[#111111]" data-id="element-126">
        <div className="max-w-lg mx-auto bg-[#1a1a1a] rounded-3xl border border-gray-800 p-8 md:p-12 text-center shadow-2xl relative" data-id="element-127">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#00ff88] text-black font-bold px-6 py-2 rounded-full uppercase tracking-wider text-sm shadow-lg" data-id="element-128">
            Oferta de Lanzamiento
          </div>

          <h2 className="text-3xl font-bold text-white mb-2" data-id="element-129">
            Rutina Exprés: Fitness 15
          </h2>
          <p className="text-gray-400 mb-8" data-id="element-130">El sistema ME15 completo</p>

          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-131">
            <span className="text-gray-500 text-2xl line-through" data-id="element-132">$17</span>
            <span className="text-6xl font-black text-[#00ff88] tracking-tighter" data-id="element-133">
              $6.97
            </span>
            <span className="text-gray-500 text-xl font-medium" data-id="element-134">USD</span>
          </div>

          <p className="text-sm text-gray-500 mb-8" data-id="element-135">
            Porque si cuesta demasiado, lo piensas. <br data-id="element-136" />Y si lo piensas… lo
            pospones.
          </p>

          <a href={CHECKOUT_URL} onClick={handleCheckoutClick} className="w-full bg-[#00ff88] hover:bg-[#00cc6a] text-black font-black text-xl py-5 px-8 rounded-xl transform transition hover:-translate-y-1 shadow-lg hover:shadow-[0_0_30px_rgba(0,255,136,0.3)] flex items-center justify-center gap-3 uppercase tracking-tight mb-6" data-id="element-137">
            Descargar Ahora
            <Zap className="w-6 h-6 fill-black" data-id="element-138" />
          </a>

          <div className="flex justify-center gap-4 text-gray-500 text-xs" data-id="element-139">
            <span className="flex items-center gap-1" data-id="element-140">
              <Shield className="w-3 h-3" data-id="element-141" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-142">
              <Check className="w-3 h-3" data-id="element-143" /> Entrega Digital
            </span>
          </div>
        </div>
      </section>

      {/* 9. FOOTER */}
      <footer className="py-12 px-4 text-center text-gray-600 text-sm bg-[#050505]" data-id="element-144">
        <p data-id="element-145">
          © {new Date().getFullYear()} Rutina Exprés. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-146">
          Este producto no sustituye el consejo médico profesional.
        </p>
        <div className="mt-4 flex justify-center gap-6" data-id="element-147">
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#00ff88] transition-colors underline underline-offset-2" data-id="element-148">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#00ff88] transition-colors underline underline-offset-2" data-id="element-149">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* STICKY MOBILE CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-[#1a1a1a]/95 backdrop-blur-md border-t border-gray-800 p-4 md:hidden z-50 flex items-center justify-between" data-id="element-150">
        <div className="flex flex-col" data-id="element-151">
          <span className="text-xs text-gray-400 uppercase" data-id="element-152">Precio único</span>
          <span className="text-2xl font-black text-[#00ff88]" data-id="element-153">$6.97 USD</span>
        </div>
        <a href={CHECKOUT_URL} onClick={handleCheckoutClick} className="bg-[#00ff88] text-black font-bold py-3 px-6 rounded-lg text-sm uppercase tracking-wide shadow-[0_0_15px_rgba(0,255,136,0.3)]" data-id="element-154">
          Empezar Ya
        </a>
      </div>

      {/* Spacer for sticky footer on mobile */}
      <div className="h-20 md:hidden" data-id="element-155"></div>

      {/* PRIVACY & TERMS MODALS */}
      {activeModal && <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={closeModal} data-id="element-156">
          <div className="bg-[#1a1a1a] rounded-2xl border border-gray-800 max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-157">
            <div className="flex items-center justify-between p-6 border-b border-gray-800" data-id="element-158">
              <h3 className="text-xl font-bold text-white" data-id="element-159">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors p-1" data-id="element-160">
                <X className="w-6 h-6" data-id="element-161" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[60vh] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-162">
              {activeModal === 'privacy' ? <>
                  <p className="text-gray-400 text-xs uppercase tracking-wide" data-id="element-163">
                    Última actualización:{' '}
                    {new Date().toLocaleDateString('es-ES', {
                month: 'long',
                year: 'numeric'
              })}
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-164">
                    1. Información que Recopilamos
                  </h4>
                  <p data-id="element-165">
                    Recopilamos información personal que nos proporcionas
                    voluntariamente al realizar una compra, incluyendo tu
                    nombre, dirección de correo electrónico y datos de pago
                    procesados de forma segura por nuestros proveedores de pago.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-166">
                    2. Uso de la Información
                  </h4>
                  <p data-id="element-167">Utilizamos tu información para:</p>
                  <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-168">
                    <li data-id="element-169">Procesar y entregar tu compra</li>
                    <li data-id="element-170">Enviarte el producto digital adquirido</li>
                    <li data-id="element-171">Comunicarnos contigo sobre tu pedido</li>
                    <li data-id="element-172">Mejorar nuestros productos y servicios</li>
                  </ul>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-173">
                    3. Protección de Datos
                  </h4>
                  <p data-id="element-174">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger tu información personal contra acceso no
                    autorizado, alteración, divulgación o destrucción.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-175">
                    4. Cookies
                  </h4>
                  <p data-id="element-176">
                    Utilizamos cookies esenciales para el funcionamiento del
                    sitio y cookies analíticas para entender cómo los visitantes
                    interactúan con nuestra página.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-177">
                    5. Tus Derechos
                  </h4>
                  <p data-id="element-178">
                    Tienes derecho a acceder, rectificar o eliminar tu
                    información personal. Para ejercer estos derechos, puedes
                    contactarnos a través de los canales disponibles.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-179">
                    6. Cambios a esta Política
                  </h4>
                  <p data-id="element-180">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Los cambios serán efectivos
                    inmediatamente después de su publicación en esta página.
                  </p>
                </> : <>
                  <p className="text-gray-400 text-xs uppercase tracking-wide" data-id="element-181">
                    Última actualización:{' '}
                    {new Date().toLocaleDateString('es-ES', {
                month: 'long',
                year: 'numeric'
              })}
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-182">
                    1. Aceptación de los Términos
                  </h4>
                  <p data-id="element-183">
                    Al acceder y utilizar este sitio web y realizar una compra,
                    aceptas estar sujeto a estos términos y condiciones de uso.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-184">
                    2. Producto Digital
                  </h4>
                  <p data-id="element-185">
                    "Rutina Exprés: Fitness 15" es un producto digital (PDF) que
                    se entrega electrónicamente después de completar la compra.
                    Recibirás acceso inmediato al contenido.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-186">
                    3. Uso Personal
                  </h4>
                  <p data-id="element-187">
                    El producto adquirido es para uso personal únicamente. Queda
                    prohibida la reproducción, distribución, modificación o
                    reventa del contenido sin autorización expresa.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-188">
                    4. Descargo de Responsabilidad
                  </h4>
                  <p data-id="element-189">
                    Este programa de ejercicios es solo para fines informativos
                    y educativos. No sustituye el consejo médico profesional.
                    Consulta con un profesional de la salud antes de comenzar
                    cualquier programa de ejercicios, especialmente si tienes
                    condiciones médicas preexistentes.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-190">
                    5. Resultados
                  </h4>
                  <p data-id="element-191">
                    Los resultados pueden variar de persona a persona. No
                    garantizamos resultados específicos ya que estos dependen de
                    múltiples factores individuales como consistencia, nutrición
                    y condición física inicial.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-192">
                    6. Política de Reembolso
                  </h4>
                  <p data-id="element-193">
                    Debido a la naturaleza digital del producto, todas las
                    ventas son finales. Sin embargo, si experimentas problemas
                    técnicos para acceder al contenido, trabajaremos contigo
                    para resolver el problema.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-194">
                    7. Propiedad Intelectual
                  </h4>
                  <p data-id="element-195">
                    Todo el contenido, incluyendo textos, gráficos, logos y
                    materiales del programa, está protegido por derechos de
                    autor y es propiedad exclusiva de Rutina Exprés.
                  </p>

                  <h4 className="text-white font-bold text-base mt-6" data-id="element-196">
                    8. Modificaciones
                  </h4>
                  <p data-id="element-197">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. El uso continuado del sitio después de
                    cualquier cambio constituye tu aceptación de los nuevos
                    términos.
                  </p>
                </>}
            </div>
            <div className="p-4 border-t border-gray-800 bg-[#111111]" data-id="element-198">
              <button onClick={closeModal} className="w-full bg-[#00ff88] hover:bg-[#00cc6a] text-black font-bold py-3 px-6 rounded-lg transition" data-id="element-199">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </div>;
}